<div class="p-2 pb-4 pt-4" style="width: 750px;" *ngIf="hasWidgets">
    <div class="font-14-bold mb-3" *ngIf="filteredResponsiveWidgets.length > 0">Widgets</div>
    <div class="d-flex form-check row ml-0 mb-2" *ngFor="let widget of filteredResponsiveWidgets">
        <div style="flex:2;" *ngIf="widget.RoleReadAccess">
            <input class="form-check-input" type="checkbox" [(ngModel)]="widget.ReadAccess"
                style="margin-top: 4px;position: absolute;" [disabled]="!editMode || widget.ReadAccess" [id]="'ResponsiveRoleCheck' + widget.ModuleID"
            />
            <label class="form-check-label font-14-regular pl-1" [for]="'ResponsiveRoleCheck' + widget.ModuleID" 
                [ngbPopover]="roleHoverMessage" placement="right" triggers="mouseenter:mouseleave"
                style="display: inline-block; white-space: normal;">
                {{widget.ModuleName}}
            </label>
        </div>
        <div style="flex:2;" *ngIf="!widget.RoleReadAccess">
            <input class="form-check-input" type="checkbox" [(ngModel)]="widget.ReadAccess" (ngModelChange)="ReadAccessChanged(widget)" [id]="'ResponsiveUserCheck' + widget.ModuleID" style="margin-top: 4px;position: absolute;" [disabled]="!editMode"/>
            <label class="form-check-label font-14-regular pl-1" [for]="'ResponsiveUserCheck' + widget.ModuleID"
                [ngbPopover]="readHoverMessage" placement="right" triggers="mouseenter:mouseleave"
                style="display: inline-block; white-space: normal;">
                {{widget.ModuleName}}
            </label>
        </div>
        <div class="font-14-regular" style="color: #A8AFB9; flex: 5; overflow: hidden; display: inline-block; white-space: normal;margin-top:2px;">{{widget.ModuleDescription}}</div>
    </div>
</div>
